import { parseISO } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

/**
 * Converts a given date string into a date object adjusted to the specified timezone.
 * If no timezone is provided, it returns the date in the local timezone.
 */
export function getZonedDate(dateString: string, defaultTimezone?: string) {
  return defaultTimezone
    ? utcToZonedTime(new Date(parseISO(dateString)), defaultTimezone)
    : new Date(parseISO(dateString));
}
